"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNSUBSCRIPTION_TYPES = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faTriangleExclamation_1 = require("@fortawesome/pro-light-svg-icons/faTriangleExclamation");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var Alerts_1 = __importDefault(require("atomicComponents/molecules/Alerts"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var RadioSelect_1 = __importDefault(require("shared/components/Form/RadioSelect"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var validators_1 = require("utils/form/validators");
var general_1 = require("utils/general");
var hooks_1 = require("utils/hooks");
var logging_1 = require("utils/logging");
var Wrapper_1 = require("../styles/Wrapper");
exports.UNSUBSCRIPTION_TYPES = ['SINGLE', 'GENERAL'];
var SUPPORT_HREF = "mailto:".concat(end2end_1.HUDLED_EMAILS.support, "?subject=Unsubscription failed");
var UnsubscribeIntegration = function () {
    var _a = (0, hooks_1.useQParams)(), email = _a.email, provider = _a.provider, notifId = _a.notifId, chk = _a.chk;
    var _b = __read(react_1.default.useState(false), 2), isUnsubscribed = _b[0], setIsUnsubscribed = _b[1];
    var _c = __read((0, backend_1.useCall)('main-unsubscribefromnotifications', { notifId: notifId, chk: chk }), 3), callUnsubscribe = _c[0], _isCalling = _c[1], error = _c[2];
    var isSubmitted = isUnsubscribed || error;
    var onSubmit = function (_a) {
        var type = _a.type;
        return __awaiter(void 0, void 0, void 0, function () {
            var result, e_1;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, callUnsubscribe({ type: type })()];
                    case 1:
                        result = _c.sent();
                        if ((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.success) {
                            setIsUnsubscribed(true);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _c.sent();
                        (0, logging_1.logInfo)('Error', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var UNSUBSCRIPTION_TYPES_MAPPER = {
        SINGLE: "This integration with ".concat(provider),
        GENERAL: 'All integrations',
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Unsubscribe?", description: "from deactivated integrations" }), (0, jsx_runtime_1.jsx)(Wrapper_1.Wrapper, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: 500, maxWidth: "90vw" }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faTriangleExclamation_1.faTriangleExclamation, size: "4x", color: "#EF5048" }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1, my: 3 }, { children: "Unsubscribe?" })), (0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3, mb: 2 }, { children: ["Please confirm that you would like to unsubscribe ", email || 'your email address', ' ', "from future notifications about:"] })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, mb: 2 }, { children: "Hudled analyses your data so you can receive real-time SaaS optimization techniques and strategies to help reduce your SaaS costs." })), !isSubmitted && ((0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: onSubmit }, { children: function (_a) {
                                var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                                return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "type", component: RadioSelect_1.default, options: (0, general_1.makeValueLabelArray)(exports.UNSUBSCRIPTION_TYPES, UNSUBSCRIPTION_TYPES_MAPPER), label: "Subscription preference options", validate: (0, validators_1.required)('Please choose an option') }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mt: 2 }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ type: "submit", disabled: submitting, sx: { mr: 1 } }, { children: "Confirm" })), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", url: "/dashboard", disabled: submitting }, { children: "Cancel" }))] }))] })));
                            } }))), isUnsubscribed && ((0, jsx_runtime_1.jsx)(Alerts_1.default, { severity: "success", message: "You have been successfully unsubscribed from these email notifications." })), error && ((0, jsx_runtime_1.jsx)(Alerts_1.default, { severity: "error", title: "Unsubscription failed", message: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Contact ", (0, jsx_runtime_1.jsx)("a", __assign({ href: SUPPORT_HREF }, { children: end2end_1.HUDLED_EMAILS.support })), " to report this error"] }) }))] })) })] }));
};
exports.default = UnsubscribeIntegration;
